@if (ignoreColor()) {
  <img
    aria-hidden="true"
    [src]="resolvedSrc()"
    [ngClass]="class()"
    [style.width]="size() + 'px'"
    [style.height]="size() + 'px'"
  />
} @else if (svgContent()) {
  <div
    aria-hidden="true"
    class="flex items-center justify-center"
    [ngClass]="class()"
    [style.width]="size() ? size() + 'px' : null"
    [style.height]="size() ? size() + 'px' : null"
    [innerHTML]="svgContent()"
  ></div>
} @else {
  <div class="flex items-center justify-center relative">
    @if (backgroundColor() && size()) {
      <div
        class="absolute top-[2px] right-[2px] rounded-full"
        [style.width]="size()! - 4 + 'px'"
        [style.height]="size()! - 4 + 'px'"
        [style.background-color]="backgroundColor()"
      ></div>
    }

    <span
      aria-hidden="true"
      class="flex items-center justify-center"
      [ngClass]="class()"
      [style.background-color]="color()"
      [style.mask-image]="maskUrl()"
      [style.-webkit-mask-image]="maskUrl()"
      [style.width]="size() + 'px'"
      [style.height]="size() + 'px'"
      [style.mask-size]="maskSize()"
      [style.-webkit-mask-size]="maskSize()"
      style="
        mask-size: contain;
        -webkit-mask-size: contain;
        mask-repeat: no-repeat;
        -webkit-mask-repeat: no-repeat;
        mask-position: center;
        -webkit-mask-position: center;
      "
    >
    </span>
  </div>
}
